import { Building2, Mail, Phone, MapPin, ExternalLink } from "lucide-react"
import { Button } from "./button"
import { Separator } from "./separator"

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-[#22395d] text-slate-300 dark:bg-surface dark:text-muted-foreground mt-auto border-t border-slate-700 dark:border-border">
      <div className="max-w-6xl mx-auto px-3 py-6 lg:py-10">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <Building2 className="w-6 h-6 text-blue-400" />
              <h3 className="text-lg font-semibold text-white">EncoAudit</h3>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Professional digital EncoAudit and inspection management system for solar installations and construction
              projects.
            </p>
            <div className="flex items-center gap-2 text-sm">
              <MapPin className="w-4 h-4 text-slate-400" />
              <span>83 Victoria Street London, United Kingdom SW1H 0HW</span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider">Quick Links</h4>
            <nav className="space-y-2 flex flex-col">
              <Button variant="link" className="h-auto p-0 text-slate-400 hover:text-white self-start">
                Dashboard
              </Button>
              <Button variant="link" className="h-auto p-0 text-slate-400 hover:text-white self-start">
                New Audit
              </Button>
              <Button variant="link" className="h-auto p-0 text-slate-400 hover:text-white self-start">
                Reports
              </Button>
              <Button variant="link" className="h-auto p-0 text-slate-400 hover:text-white self-start">
                Settings
              </Button>
            </nav>
          </div>

          {/* Support */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider">Support</h4>
            <nav className="space-y-2">
              <div className="flex items-center gap-1">
                <Button variant="link" className="h-auto p-0 text-slate-400 hover:text-white justify-start">
                  Help Center
                </Button>
                <ExternalLink className="w-3 h-3 ml-1" />
              </div>

              <div className="flex items-center gap-1">
                <Button variant="link" className="h-auto p-0 text-slate-400 hover:text-white justify-start">
                  Documentation
                </Button>
                <ExternalLink className="w-3 h-3 ml-1" />
              </div>

              <div className="flex items-center gap-1">
                <Button variant="link" className="h-auto p-0 text-slate-400 hover:text-white justify-start">
                  API Reference
                </Button>
                <ExternalLink className="w-3 h-3 ml-1" />
              </div>

              <div className="flex items-center gap-1">
                <Button variant="link" className="h-auto p-0 text-slate-400 hover:text-white justify-start">
                  Contact Support
                </Button>
                <ExternalLink className="w-3 h-3 ml-1" />
              </div>

            </nav>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-2 text-sm">
                <Mail className="w-4 h-4 text-slate-400" />
                <a href="mailto:support@siteauditpro.com" className="hover:text-white transition-colors">
                  info@greenenco.co.uk
                </a>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <Phone className="w-4 h-4 text-slate-400" />
                <a href="tel:+441234567890" className="hover:text-white transition-colors">
                  +44(0)7523920132
                </a>
              </div>
              <div className="text-sm text-slate-400">
                <p>Monday - Friday</p>
                <p>9:00 AM - 5:00 PM GMT</p>
              </div>
            </div>
          </div>
        </div>

        <Separator className="my-4 bg-slate-700" />

        {/* Bottom Footer */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="text-sm text-slate-400">© {currentYear} EncoAudit. All rights reserved.</div>
          <div className="flex items-center gap-6 text-sm">
            <Button variant="link" className="h-auto p-0 text-slate-400 hover:text-white">
              Privacy Policy
            </Button>
            <Button variant="link" className="h-auto p-0 text-slate-400 hover:text-white">
              Terms of Service
            </Button>
            <Button variant="link" className="h-auto p-0 text-slate-400 hover:text-white">
              Cookie Policy
            </Button>
          </div>
        </div>
      </div>
    </footer>
  )
}
